import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Message } from 'src/app/models/WebServer/message';
import { AppConfigService } from 'src/app/services/app.config.service';

import { AppHelper } from 'src/app/helpers/app.helper';
import { ImageHelper } from 'src/app/helpers/image.helper';
import { EventService } from 'src/app/services/event.service';
import { WhiteboardService } from 'src/app/services/whiteboard.service';
import { markMediaAsSeen } from 'src/app/store/actions/app.actions';
import { AppState } from 'src/app/store/states/app.state';
import { SvgConstants } from 'src/app/svgConstants';




@Component({
  selector: 'app-camera-gallery',
  templateUrl: './camera-gallery.component.html',
  styleUrls: ['./camera-gallery.component.scss']
})
export class CameraGalleryComponent {
  @ViewChild('gallery', {static: false}) gallery?: ElementRef;

  @Input() AS!: AppState;
  @Input() set display(value: boolean) {
    console.log(`mediaService - CameraGalleryComponent display: ${value}`);
    if (value) {
      this.setCurrentImageAsRead();
    }
    this._display = value;
  }
  // whiteboardImage?: CanvasData;
  _display = false;
  loading = true;
  currentPhoto = 0;
  currentImageUrl: any;
  imageLoadPath = 'assets/images/imgLoad.svg';
  svgConstants = SvgConstants;

  constructor(
    private store: Store,
    private eventService: EventService,
    public config: AppConfigService,
    public whiteboardService: WhiteboardService
  ) { }

  manageImageError(event: any, message: Message) {
    const image = event.target;
    if (image.src) {
      if (image.src !== 'assets/images/notFound.jpg') {
        if (image.src.startsWith('unsafe')) {
          image.src = image.src.replace('unsafe:', '');
          // message.content = 'Image here has been removed from server'; //TODO non può essere modificato (immutable)
        } else {
          image.src = 'assets/images/notFound.jpg';
          image.onerror = null;
          // message.content = 'Image here has been removed from server';//TODO non può essere modificato (immutable)
        }
      }
    }
  }

  // private CheckRead() {
  //   if (!this.AS.mediaMessages || this.AS.mediaMessages.length == 0) return true;

  //   var image = this.AS.mediaMessages[this.currentPhoto];
  //   if (!image) return true;
  //   return !!image.messageInfo && !!image.messageInfo.readAt && !this.badgeBlink;
  // }

  badgeBlink = false;
  private blinkBadgeUnseen() {
    const self = this;
    var blinkCount = 5;
    this.badgeBlink = true;
    const blinkInterval = window.setInterval( () =>{
      self.badgeBlink = !self.badgeBlink;
      blinkCount--;
      if (blinkCount < 0) {
        self.badgeBlink = false;
        window.clearInterval(blinkInterval);
      }
      // console.log(`****** blink ${self.badgeBlink}`)
    }, 600)
  }

  setCurrentImageAsRead() {
    if (!this.AS.mediaMessages || this.AS.mediaMessages.length == 0) return;

    var image = this.AS.mediaMessages[this.currentPhoto];

    if (!image || (image.messageInfo && image.messageInfo.readAt)) return;

    this.store.dispatch(markMediaAsSeen({mediaIdx: this.currentPhoto}));
    this.blinkBadgeUnseen();

  }

  prevPhoto() {
    this.loading = true;
    this.currentPhoto = (this.currentPhoto - 1) >= 0 ? (this.currentPhoto - 1) % this.AS.mediaMessages.length : this.AS.mediaMessages.length - 1;
    this.setCurrentImageAsRead();
  }

  nextPhoto() {
    this.loading = true;
    this.currentPhoto = (this.currentPhoto + 1) % this.AS.mediaMessages.length;
    this.setCurrentImageAsRead();
  }

  whiteboardPhoto() {
    if(!this.gallery) return;

    const photoContainer = this.gallery.nativeElement.children[this.currentPhoto];
    if(!photoContainer) return;
    const img: HTMLImageElement = photoContainer.firstChild;
    let canvas = AppHelper.getCanvasFromImage(img);
    if(!canvas) return;

    // Ridimensiona il canvas se supera le dimensioni massime configurate
    const maxDimensions = this.config.maxImageDimensions;
    const originalDimensions = `${canvas.width}x${canvas.height}`;
    canvas = AppHelper.resizeCanvasIfNeeded(canvas, maxDimensions.width, maxDimensions.height);

    // Usa JPEG con qualità 0.9 invece di PNG per ridurre le dimensioni
    let canvasString = canvas.toDataURL('image/jpeg', 0.9);

    // Comprimi l'immagine se supera la dimensione desiderata (2.7MB di default)
    const originalSize = canvasString.length;
    ImageHelper.resizeImage(canvasString, this.config.desiredImageSize, canvas);
    canvasString = canvas.toDataURL('image/jpeg', 0.9);

    console.log(`Whiteboard image from gallery - original: ${originalDimensions}, final: ${canvas.width}x${canvas.height}, compression: ${originalSize} → ${canvasString.length} bytes (${Math.round((1 - canvasString.length/originalSize) * 100)}% reduction)`);

    const this_whiteboardImage={
      id: AppHelper.newUUID,
      height: canvas.height,
      image: canvasString,
      width: canvas.width
    }

    this.config.setWhiteboardCanvasToEdit(this_whiteboardImage);
    this.whiteboardService.open(this_whiteboardImage);
    const sub = this.whiteboardService.onClose$.subscribe(saved => {
      // if(saved) {
        this.config.whiteboardReset()
      // }
      sub.unsubscribe();
    });
    // const url = this.AS.mediaMessages[this.currentPhoto].content;
    // AppHelper.getBase64ImageFromUrl(url, img.width, img.height).then( data =>{
    //   this.whiteboardImage = data;

    // })
  }

  downloadImage(idx: number) {
    const url = this.AS.mediaMessages[idx].content;
    const fileName = this.AS.mediaMessages[idx].fileName;
    AppHelper.downloadFile(url, fileName);
  }

  imageLoaded() {
    this.loading = false;
    if(this._display)
    this.setCurrentImageAsRead();
  }
}
